var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "with-border" },
    [
      _c("div", { staticClass: "data pt-15 pb-15" }, [
        _c("div", [
          _c("div", { staticClass: "sub-title" }, [
            _vm._v(
              "Limpeza de " +
                _vm._s(
                  _vm._f("secToHours")(_vm.order.schedule_event.duration)
                ) +
                " horas"
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "mb-0" }, [
            _vm._v(
              "DIA: " +
                _vm._s(
                  _vm._f("formatDate")(
                    _vm.order.schedule_event.starts_at,
                    "DD/MM/Y [às] HH [horas]"
                  )
                )
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "mt-0 mb-0" }, [
            _vm._v(
              "com " +
                _vm._s(_vm.order.professional.account.first_name) +
                " " +
                _vm._s(_vm.order.professional.account.last_name)
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pricing float text-right" }, [
          _c("span", { staticClass: "price" }, [
            _vm._v(_vm._s(_vm._f("intToCurrency")(_vm.order.total)))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("holiday-warning", {
        attrs: { day: _vm.order.schedule_event.starts_at }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9370c0fe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9370c0fe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Checkout/Payment/OrderData.vue
// module id = null
// module chunks = 